export default __webpack_public_path__ + "static/columnHeaders-03f862588b7bf265df2f5e45d1138e19.gif";